import { render, staticRenderFns } from "./ParUpdateActiveButton.vue?vue&type=template&id=e92651ce&"
import script from "./ParUpdateActiveButton.vue?vue&type=script&lang=js&"
export * from "./ParUpdateActiveButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports